import api from "../../../";
import type { ApiResponse } from "../../../types";
import type { CommunityAnswer, UpdateCommunityAnswerParams } from "./types";

export const patchCommunityAnswer = async ({ id, body }: UpdateCommunityAnswerParams): Promise<CommunityAnswer | null> => {
  return await api.patch<ApiResponse<CommunityAnswer>>(`/admin/sepehr/answers/${id}/`, body)
    .then((res) => res.data.data)
    .catch(() => null);
};

